// src/array/index.ts
function scalarArraysAreEqual(array1, array2) {
  if (array1.length !== array2.length) return false;
  const a1 = [...array1].sort();
  const a2 = [...array2].sort();
  return a1.every((value, index) => value === a2[index]);
}

export {
  scalarArraysAreEqual
};
//# sourceMappingURL=chunk-YXIU4MRC.mjs.map